import { render, staticRenderFns } from "./QuickviewCustomer.vue?vue&type=template&id=c7016a1c&scoped=true&"
import script from "./QuickviewCustomer.vue?vue&type=script&lang=js&"
export * from "./QuickviewCustomer.vue?vue&type=script&lang=js&"
import style0 from "./QuickviewCustomer.vue?vue&type=style&index=0&id=c7016a1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7016a1c",
  null
  
)

export default component.exports